export enum AppNames {
  Sherlock = 'Sherlock',
  CryptoService = 'Crypto Service',
  Watson = 'Watson',
  Sima = 'Sima',
  Reco = 'Reco',
  Settings = 'Settings',
  Ruby = 'Ruby',
  Busy = 'Busy',
  Gaya = 'Gaya',
  CommPlatform = 'Comm Platform',
  IncidentManagement = 'Incident Management',
  Subscription = 'Subscription',
  FeatureStrategyBuilder = 'Feature Strategy Builder',
  PathFinder = 'Path Finder',
  MelioLlmPlayground = 'Melio LLM Playground',
  FeeManagement = 'Fees Management',
  ActivityAgent = 'Activity Agent',
  AgentBuilder = 'Agent Builder',
  Melgov = 'Melgov'
}
